import React, { useEffect } from "react";
import { Col, Form } from "react-bootstrap";
import { translate } from "../../components/Language/Translate";
import { textbausteinTypes1 } from "../../components/Textbausteine/textbausteinTypes";
import FormField from "../FormField";
import FieldGroup from "./FieldGroup";

const SchuelerFormFields = ({ props }) => {
  // const [showFieldErrors, setShowFieldErrors] = useState(false)
  const {
    fieldSettings,
    handleSubmit,
    handleSaveEntwurf,
    setView,
    variables,
    setVariables,
    fieldErrors,
    showFieldErrors,
  } = props;

  useEffect(() => {
    if (!variables.prozentAfb1 || !variables.prozentAfb2) return;
    setVariables((vars) => {
      return {
        ...vars,
        prozentAfb3: 100 - variables.prozentAfb1 - variables.prozentAfb2,
      };
    });
  }, [variables.prozentAfb1, variables.prozentAfb2, setVariables]);



  return (
    <div
      className="m-2 p-3"
      style={{ border: "1px solid grey", borderRadius: "5px" }}
    >
      <Form>
        <Form.Row>
          {["vorname", "nachname", "leseschwaeche"].map((i) => {
            const lf = fieldSettings[i];
            if (!lf) return null;
            return (
              <Col key={lf.name} id={lf.name} className={`col-${lf.col}`}>
                <FormField props={{ ...props, name: lf.name }} />
              </Col>
            );
          })}
        </Form.Row>
        <FieldGroup
          title={textbausteinTypes1.afb1Tb.headline}
          fieldnames={["afb1Points", "afb1Tb", "afb1Remarks"]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.afb2Tb.headline}
          fieldnames={["afb2Points", "afb2Tb", "afb2Remarks"]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.afb3Tb.headline}
          fieldnames={["afb3Points", "afb3Tb", "afb3Remarks"]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.spracheTb.headline}
          fieldnames={["sprachePoints", "spracheTb", "spracheRemarks"]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.spracheKorrektTb.headline}
          fieldnames={[
            "spracheKorrektPoints",
            "spracheKorrektTb",
            "spracheKorrektRemarks",
          ]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.spracheAusdruckTb.headline}
          fieldnames={[
            "spracheAusdruckPoints",
            "spracheAusdruckTb",
            "spracheAusdruckRemarks",
          ]}
          props={props}
        />{" "}
        <FieldGroup
          title={textbausteinTypes1.spracheLesenTb.headline}
          fieldnames={[
            "spracheLesenPoints",
            "spracheLesenTb",
            "spracheLesenRemarks",
          ]}
          props={props}
        />
        <Form.Row>
          {["zusammenfassung"].map((i) => {
            const lf = fieldSettings[i];
            return (
              <Col key={lf.name} id={lf.name} className={`col-${lf.col}`}>
                <FormField props={{ ...props, name: lf.name }} />
              </Col>
            );
          })}
        </Form.Row>
        {showFieldErrors && Object.keys(fieldErrors).length > 0 ? (
          <p style={{color:"darkred"}}>
            Es fehlen noch Eingaben. Bitte füllen Sie die rot umrandeten Felder
            aus, oder speichern Sie das Gutachten als Entwurf.
          </p>
        ) : null}
        <Form.Row>
          <Col>
            <button
              block
              className="btn btn-outline-dark"
              onClick={handleSubmit}
            >
              Gutachten speichern
            </button>
          </Col>
          <Col>
            <button
              block
              className="btn btn-outline-dark"
              onClick={handleSaveEntwurf}
            >
              Gutachten als Entwurf speichern
            </button>
          </Col>
          <Col>
            <button
              block
              className="btn btn-outline-dark"
              onClick={() => setView("buttons")}
            >
              {translate("Cancel")}
            </button>
          </Col>
        </Form.Row>
      </Form>
    </div>
  );
};
export default SchuelerFormFields;
